module.exports = __webpack_public_path__ + "img/arrow-up.7bcc217a.svg";